import Menu from "web/components/DropDownMenu/Menu"

import { IconButton } from "web/components"
export default function SettingsMenu({
  size,
  menuItems = [],
  position,
  title,
  listWidth,
}) {
  return (
    <Menu>
      {({ open }) => (
        <>
          <Menu.Button>
            <IconButton
              name="ellipsis-horizontal"
              active={open}
              size={size}
              as="div"
              data-testid="settings-menu-button"
            />
          </Menu.Button>
          <Menu.Items open={open} position={position} listWidth={listWidth}>
            <Menu.FullScreenHeader title={title} />
            {menuItems.map((item) => {
              const ItemIcon = item?.icon
              return (
                <Menu.Item
                  onClick={item.onClick}
                  key={item.label}
                  disabled={item.disabled}
                >
                  <button
                    key={item.label}
                    className="flex w-full items-center rounded-md p-2 text-sm text-neutral-1"
                  >
                    {ItemIcon && (
                      <ItemIcon
                        className="mr-2 h-5 w-5 text-neutral-4"
                        aria-hidden="true"
                      />
                    )}
                    {item.label}
                  </button>
                </Menu.Item>
              )
            })}
          </Menu.Items>
        </>
      )}
    </Menu>
  )
}
